import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { ISessionReducer, Mode } from 'core/slices/session';
import { IPreviewState } from 'core/slices/preview';

const session = (state: RootState) => state.session;
const preview = (state: RootState) => state.preview;

export const selectVariableRegister = createSelector(
  [session, preview],
  (session: ISessionReducer, preview: IPreviewState) => {
    return session.mode === Mode.PREVIEW ? preview.variables : session.variables;
  },
);
